// extracted by mini-css-extract-plugin
module.exports = {"buttons-outer":"a10a3f92e9--buttons-outer--d9hC7","complaint-outer":"a10a3f92e9--complaint-outer--d1l5h","tooltip":"a10a3f92e9--tooltip--kRbws"};